import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiBasePath, apiName } from 'assets';
import TinyAccount from 'types/TinyAccount';

const updateTinyAccount = async (
  tinyAccountId: string,
  body: Partial<TinyAccount>,
) => {
  if (!tinyAccountId) throw new Error('No tiny account Id provided');
  try {
    await API.put(
      apiName,
      `${apiBasePath}/tinyaccounts/${tinyAccountId}`,
      {
        body,
      },
      true,
      undefined,
      {
        tags: {
          section: SECTIONS.PROFILE,
          domain: DOMAINS.ACCOUNT,
          importance: IMPORTANCE.HIGH,
        },
        context: {
          tinyAccountId,
        },
      },
    );
  } catch (err) {
    toast.error('Error updating tiny account');
  }
};

const useUpdateTinyAccount = () => {
  const queryClient = useQueryClient();
  const tinyAccountMutation = useMutation({
    mutationFn: ({
      tinyAccountId,
      body,
    }: {
      tinyAccountId: string;
      body: Partial<TinyAccount>;
    }) => {
      return updateTinyAccount(tinyAccountId, body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tinyAccounts'] });
    },
  });
  return tinyAccountMutation;
};

export default useUpdateTinyAccount;
